
import api from "services/api/Api";
import auth from "./Auth";
import { ApiPaths } from "services/api/ApiPaths";
import LoadingSpinner from "components/library/loading-spinner/LoadingSpinner";
import { useDispatch } from "react-redux";
import { setUserProfile } from "store/reducers/user";
import useSWR from 'swr';
import { z } from "zod";
import ValidateApiSchema from "services/validators/ValidateApiSchema";
import { setConfig } from "store/reducers/config";

interface PropsModel {
    children: React.ReactNode
}

const ConfigSchema = z.object({
    casServiceClientId: z.string(),
    casServiceUrl: z.string().url(),
    version: z.string(),
    tpscBaseUri: z.string()
});


type TConfig = z.infer<typeof ConfigSchema>


const ConfigInitializer = (props: PropsModel) => {
    const dispatch = useDispatch()

    const fetchConfig = async (): Promise<TConfig> => {
        const response = await api.get(ApiPaths.GET_CONFIGURATION)
        return ValidateApiSchema(response, ConfigSchema)
    }

    const { isLoading } = useSWR<TConfig>(ApiPaths.GET_CONFIGURATION, fetchConfig, {
        onSuccess: (data: TConfig) => {
            auth.initProvider(data);
            dispatch(setUserProfile(auth.getProfile()));
            dispatch(setConfig(`${data.tpscBaseUri}/2025/return/`));
        }
    })

    return isLoading ? <LoadingSpinner /> : <div>{props.children}</div>;
}

export default ConfigInitializer;
